import DashboardLayout from '../../components/layout/DashboardLayout';
import PartsCatalogPanel from './PartsCatalog';

/**
 * Standalone Parts Price Catalog page — accessible to clerks (with
 * can_view_auto_spares permission), admins, and all auto-spares roles.
 * Uses the shared dashboard chrome (sidebar, header) so it feels native
 * to the clerk / admin side. Clerks land here via the sidebar link.
 */
export default function PartsCatalogPage() {
  return (
    <DashboardLayout>
      <div className="bg-slate-900 -mx-4 lg:-mx-6 -mt-4 lg:-mt-6 px-4 lg:px-6 py-4 min-h-[calc(100vh-4rem)]">
        <PartsCatalogPanel />
      </div>
    </DashboardLayout>
  );
}
